export default __webpack_public_path__ + "e997f80c7eb99e0ef336f6411dd2fffd.png";